import { render, staticRenderFns } from "./topSection.vue?vue&type=template&id=6c435965&scoped=true&lang=html&"
import script from "./topSection.vue?vue&type=script&lang=js&"
export * from "./topSection.vue?vue&type=script&lang=js&"
import style0 from "./topSection.vue?vue&type=style&index=0&id=6c435965&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c435965",
  null
  
)

export default component.exports